import { BaseModel, type RelationConfig } from './base';

import { Employee } from './employee';

// Enums

export enum PurchaseOrderStatus {
  open = 0,
  sent = 1,
  receiving = 2,
  complete = 3,
}

export const PurchaseOrderStatusLabels: Record<PurchaseOrderStatus, string> = {
  [PurchaseOrderStatus.open]: 'general.open',
  [PurchaseOrderStatus.sent]: 'general.sent',
  [PurchaseOrderStatus.receiving]: 'order.receiving',
  [PurchaseOrderStatus.complete]: 'general.complete',
};

// Helper Classes

export class PurchaseOrderItem extends BaseModel {
  idPurchaseOrderItem!: number;
  receivedQuantity!: number;

  override objectID(): string | null {
    return this.idPurchaseOrderItem?.toString() ?? null;
  }
}

export class PurchaseOrderData extends BaseModel {
  items!: PurchaseOrderItem[];

  static override relations(): RelationConfig {
    return {
      items: { type: PurchaseOrderItem },
    };
  }
}

export class PurchaseOrderFilterResponse extends BaseModel {}

// Main Model

export class PurchaseOrder extends BaseModel {
  idPurchaseOrder!: number;
  status!: PurchaseOrderStatus;
  data!: PurchaseOrderData | null;
  employee!: Employee | null;

  static override relations(): RelationConfig {
    return {
      data: { type: PurchaseOrderData },
      employee: { type: Employee },
    };
  }

  override objectID(): string | null {
    return this.idPurchaseOrder?.toString() ?? null;
  }

  get isStatusOpen(): boolean {
    return this.status === PurchaseOrderStatus.open;
  }

  get isStatusSent(): boolean {
    return this.status === PurchaseOrderStatus.sent;
  }

  get isStatusReceiving(): boolean {
    return this.status === PurchaseOrderStatus.receiving;
  }

  get isStatusComplete(): boolean {
    return this.status === PurchaseOrderStatus.complete;
  }
}
